import { areaConstants } from '../../_constants';

export function areas(state = {}, action) {
    switch (action.type) {
        case areaConstants.AREA_RESET: 
            return {};
        case areaConstants.AREA_FETCHING:
            return {
                ...state,
                areaFetching: true
            };
        case areaConstants.AREA_FETCHED:
            return {
                ...state,
                areaFetching: false
            };
        case areaConstants.AREA_SUBMITTING:
            return {
                ...state,
                areaSubmitting: true
            };
        case areaConstants.AREA_SUBMITTED:
            return {
                ...state,
                areaSubmitting: false
            };
        case areaConstants.GET_AREAS:
            return {
                ...state,
                areas: action.areas,
            };
        case areaConstants.GET_AREA_BY_ID:
            return {
                ...state,
                area: action.area
            };
        case areaConstants.GET_ACTIVE_AREAS:
            return {
                ...state,
                activeAreas: action.activeAreas
            };
        case areaConstants.GET_ACTIVE_AREAS_WITH_BRANCH:
            return {
                ...state,
                areasBranch: action.areasBranch
            };
        default:
            return state;
    }
}